module.exports = __webpack_public_path__ + "img/klimov.469b6a67.jpg";